import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import Router from "./Router";
import "./index.css";
import { ContextProvider } from "./Providers/ContextProvider";
import { Provider } from "react-redux";
import store from "./Managment/store";

ReactDOM.createRoot(document.getElementById("root")).render(
  <ContextProvider>
    <Provider store={store}>
      <RouterProvider router={Router} />
    </Provider>
  </ContextProvider>,
);
